$(function() {
  const successMsg = 'Your email has been sent. We will get back to you as soon as possible. Thank you for your interest in hiring the Wright Voice!';
  const failMsg = "An unknown error has occurred. Please try again. If things still aren't cooperating please just pick up the phone and give us a call!";

  var processFormResults = function($form, data) {
    let $alert = $form.parent().find('.alert');
    if (!$alert.length) {
      $alert = $('<div/>').addClass('alert').addClass('alert-dismissable');
      $alert.append('<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>');
      $alert.append('<h4 class="alert-heading"></h4>');
      $alert.append('<div class="alert-content">');
      $form.before($alert);
    } 
    else {
      $alert.removeClass('alert-danger').find('.alert-content').text(''); //reset
    }
    
    if (data.success) {
      $form.slideUp();
      $alert.addClass('alert-success').find('.alert-heading').text('Success!');
      $alert.find('.alert-content').append(data.message);
    }
    else {
      $alert.addClass('alert-danger');
      if (data.errors) {
        var msg = '<p>Please correct the following and try again:</p><ul>';
        $.each(data.errors, function(i, el) {
          msg += `<li>${el}</li>`; 
        })
        msg += '</ul>';
        $alert.find('.alert-content').append(msg);
      }
      else {
        $alert.find('.alert-heading').text('Uh oh');
        $alert.find('.alert-content').append(failMsg);
      }

    }

    $alert.on('closed.bs.alert', function () {
      if (data.success) {
        $(':input', $form).val('');
      }
      $form.slideDown();
    })
  }

  // process the form
  $('form').on('submit', function(e) {
      const $form = $(this);
      
      // process the form
      $.ajax({
          type : 'POST',
          url  : '/',
          data : $form.serialize()
      })
        .done(function() {
          processFormResults($form, {
            success: true,
            message: successMsg
          });
        })
        .fail(function() {
          processFormResults($form, { success: false });
        });

      // stop the form from submitting the normal way and refreshing the page
      e.preventDefault();
  });

});